import {useCallback, useEffect} from 'react';
import {useActivate} from 'react-activation';
import {callHandlers} from '@baidu/health-tool-box-bridge';
import {isDoctorApp} from '@/utils/utils';


export default function useSetPageTitle(title: string) {
    const setPageTitle = useCallback(
        async () => {
            if (isDoctorApp() && title) {
                const res = await callHandlers.common.setWebViewTitle({title});
                console.info(res);
            }
        },
        [title]
    );
    useEffect(
        () => {
            setPageTitle();
        },
        [setPageTitle]
    );

    useActivate(setPageTitle);
}
